$(function() {

	$(".c-history__wrap .item").each(function(){
		var self = $(this);
		$(this).waypoint(function(){
				self.addClass('animate');
			},{

			offset: 'bottom-in-view',

		});
	});

  $(".c-image-with-comments__point").each(function(){
    var self = $(this);
    $(this).waypoint(function(){
      self.addClass('animate');
    },{


      offset: '60%',

    });
  });

  $(".c-benefits-design").each(function(){
    var self = $(this);
    $(this).waypoint(function(){
      self.addClass('animate');

      $('.count').each(function () {
        $(this).prop('Counter',0).animate({
          Counter: $(this).text()
        }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now));
          }
        });
      });
      this.destroy();
    },{

      offset: '80%',

    });
  });

});
